import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { MyKnownError, thunkErrorHandler } from 'features/thunkError';
import { AppDispatch } from 'app/store';
import { ICoupon } from './couponInfoTypes';
import { fetchCouponById, fetchCouponByPromotionCode } from 'api/billing/coupons';

export const getCouponById = createAsyncThunk<
  ICoupon,
  string,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@couponInfo/getCouponById', async (id, thunkApi) => {
  try {
    const res = await fetchCouponById(id);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const getCouponByPromotionCode = createAsyncThunk<
  ICoupon,
  string,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@couponInfo/getCouponByPromotionCode', async (promotionCode, thunkApi) => {
  try {
    const res = await fetchCouponByPromotionCode(promotionCode);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const clearCouponInfo = createAction('@couponInfo/clearCouponInfo');
